export const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone

const DAY_SECONDS = 60 * 60 * 24
export const FIVE_DAYS_SECONDS = DAY_SECONDS * 5
export const SUCCESS = 'success'
export const ERROR = 'error'

// localStorage key name to record the user's login time
export const USER_LOGIN_TIME = 'ftg_userlogintime'
